const getScrollbarWidth = () => {
  try {
    // Creating invisible container
    const outer = document.createElement('div')
    outer.style.visibility = 'hidden'
    outer.style.overflow = 'scroll' // forcing scrollbar to appear
    document.body.appendChild(outer)

    // Creating inner element and placing it in the container
    const inner = document.createElement('div')
    outer.appendChild(inner)

    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth) / 2

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer)
    return scrollbarWidth
  } catch (e) {
    return 0
  }
}

export const fullBleedStyles = {
  width: `calc(100vw - ${getScrollbarWidth()}px)`,
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw'
}
